module.exports = __webpack_public_path__ + "img/amx-8.0b2fbf88.jpg";